<template>
  <div class="wrapper" id="credit-card">
    <div class="card-form">
      <div class="card-list">
        <div class="card-item" v-bind:class="{ '-active' : isCardFlipped }">
          <div class="card-item__side -front">
            <div class="card-item__focus" v-bind:class="{'-active' : focusElementStyle }" v-bind:style="focusElementStyle" ref="focusElement"></div>
            <div class="card-item__cover">
              <img
              v-bind:src="'/img/cc/cc-bg-0' + currentCardBackground + '.jpg'" class="card-item__bg">
            </div>
            
            <div class="card-item__wrapper">
              <div class="card-item__top">
                <img src="/img/cc/chip.png" class="card-item__chip">
                <div class="card-item__type">
                  <transition name="slide-fade-up">
                    <img v-bind:src="'/img/cc/' + getCardType + '.png'" v-if="getCardType" v-bind:key="getCardType" alt="" class="card-item__typeImg">
                  </transition>
                </div>
              </div>
              <label for="cardNumber" class="card-item__number" ref="cardNumber">
                <template v-if="getCardType === 'amex'">
                  <span v-for="(n, $index) in amexCardMask" :key="$index">
                    <transition name="slide-fade-up">
                      <div
                        class="card-item__numberItem"
                        v-if="$index > 4 && $index < 14 && cardNumber.length > $index && n.trim() !== ''"
                      >*</div>
                      <div class="card-item__numberItem"
                        :class="{ '-active' : n.trim() === '' }"
                        :key="$index" v-else-if="cardNumber.length > $index">
                        {{cardNumber[$index]}}
                      </div>
                      <div
                        class="card-item__numberItem"
                        :class="{ '-active' : n.trim() === '' }"
                        v-else
                        :key="$index + 1"
                      >{{n}}</div>
                    </transition>
                  </span>
                </template>

                <template v-else>
                  <span v-for="(n, $index) in otherCardMask" :key="$index">
                    <transition name="slide-fade-up">
                      <div
                        class="card-item__numberItem"
                        v-if="$index > 4 && $index < 15 && cardNumber.length > $index && n.trim() !== ''"
                      >*</div>
                      <div class="card-item__numberItem"
                        :class="{ '-active' : n.trim() === '' }"
                        :key="$index" v-else-if="cardNumber.length > $index">
                        {{cardNumber[$index]}}
                      </div>
                      <div
                        class="card-item__numberItem"
                        :class="{ '-active' : n.trim() === '' }"
                        v-else
                        :key="$index + 1"
                      >{{n}}</div>
                    </transition>
                  </span>
                </template>
              </label>
              <div class="card-item__content">
                <label for="cardName" class="card-item__info" ref="cardName">
                  <div class="card-item__holder">Nome do Titular</div>
                  <transition name="slide-fade-up">
                    <div class="card-item__name" v-if="cardName.length" key="1">
                      <transition-group name="slide-fade-right">
                        <span class="card-item__nameItem" v-for="(n, $index) in cardName.replace(/\s\s+/g, ' ')" v-bind:key="$index + 1">{{n}}</span>
                      </transition-group>
                    </div>
                    <div class="card-item__name" v-else key="2">SEU NOME</div>
                  </transition>
                </label>
                <div class="card-item__date" ref="cardDate">
                  <label for="cardMonth" class="card-item__dateTitle">Validade</label>
                  <label for="cardMonth" class="card-item__dateItem">
                    <transition name="slide-fade-up">
                      <span v-if="cardMonth" v-bind:key="cardMonth">{{cardMonth}}</span>
                      <span v-else key="2">MM</span>
                    </transition>
                  </label>
                  /
                  <label for="cardYear" class="card-item__dateItem">
                    <transition name="slide-fade-up">
                      <span v-if="cardYear" v-bind:key="cardYear">{{String(cardYear).slice(2,4)}}</span>
                      <span v-else key="2">YY</span>
                    </transition>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="card-item__side -back">
            <div class="card-item__cover">
              <img
              v-bind:src="'/img/cc-bg-0' + currentCardBackground + '.jpeg'" class="card-item__bg">
            </div>
            <div class="card-item__band"></div>
            <div class="card-item__cvv">
                <div class="card-item__cvvTitle">CVV</div>
                <div class="card-item__cvvBand">
                  <span v-for="(n, $index) in cardCvv" :key="$index">
                    *
                  </span>

              </div>
                <div class="card-item__type">
                    <img v-bind:src="'/img/cc/' + getCardType + '.png'" v-if="getCardType" class="card-item__typeImg">
                </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-form__inner">
        <div class="card-input">
          <label for="cardNumber" class="card-input__label" :class="{'error' : errNumber}">Número do Cartão</label>
          <input type="text" id="cardNumber" class="card-input__input" :class="{'error' : errNumber}" v-mask="generateCardNumberMask" v-model="cardNumber" v-on:focus="focusInput" v-on:blur="blurInput" data-ref="cardNumber" autocomplete="on">
        </div>
        <div class="card-input">
          <label for="cardName" class="card-input__label" :class="{'error' : errName}">Nome do Titular</label>
          <input type="text" id="cardName" class="card-input__input" :class="{'error' : errName}" v-model="cardName" v-on:focus="focusInput" v-on:blur="blurInput" data-ref="cardName" autocomplete="on">
        </div>
        <div class="card-form__row">
          <div class="card-form__col">
            <div class="card-form__group">
              <label for="cardMonth" class="card-input__label" :class="{'error' : errMonth || errYear}">Validade</label>
              <select class="card-input__input -select"  :class="{'error' : errMonth}" id="cardMonth" v-model="cardMonth" v-on:focus="focusInput" v-on:blur="blurInput" data-ref="cardDate" autocomplete="on">
                <option value="" disabled selected>Mês</option>
                <option v-bind:value="n < 10 ? '0' + n : n" v-for="n in 12" v-bind:disabled="n < minCardMonth" v-bind:key="n">
                  <span v-if="n < 10">{{'0' + n}}</span>
                  <span v-if="n >= 10">{{n}}</span>
                </option>
              </select>
              <select class="card-input__input -select" :class="{'error' : errYear}" id="cardYear" v-model="cardYear" v-on:focus="focusInput" v-on:blur="blurInput" data-ref="cardDate" autocomplete="on">
                <option value="" disabled selected>Ano</option>
                <option v-bind:value="$index + minCardYear" v-for="(n, $index) in 12" v-bind:key="n">
                    {{$index + minCardYear}}
                </option>
              </select>
            </div>
          </div>
          <div class="card-form__col -cvv">
            <div class="card-input">
              <label for="cardCvv" class="card-input__label" :class="{'error' : errCvv}">CVV</label>
              <input type="text" class="card-input__input" :class="{'error' : errCvv}" id="cardCvv" v-mask="'####'" maxlength="4" v-model="cardCvv" v-on:focus="flipCard(true)" v-on:blur="flipCard(false)" autocomplete="off">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    defaultCardName: {
      type: String
    }
  },
  data() {
    return {
      currentCardBackground: Math.floor(Math.random()* 3 + 1), // just for fun :D
      cardName: this.defaultCardName,
      cardNumber: "",
      cardMonth: "",
      cardYear: "",
      cardCvv: "",

      errName: false,
      errNumber: false,
      errMonth: false,
      errYear: false,
      errCvv: false,

      minCardYear: new Date().getFullYear(),
      amexCardMask: "#### ###### #####",
      otherCardMask: "#### #### #### ####",
      cardNumberTemp: "",
      isCardFlipped: false,
      focusElementStyle: null,
      isInputFocused: false
    };
  },
  mounted() {    
    this.cardNumberTemp = this.otherCardMask;
    document.getElementById("cardNumber").focus();
  },
  computed: {
    getCardType () {
      let number = this.cardNumber;
      number = number.replaceAll(" ", "");
      console.log(number);
      
      let re = new RegExp(/^4[0-9]{12}(?:[0-9]{3})?$/);
      if (number.match(re) != null) return "visa";

      re = new RegExp("^(34|35|37)");
      if (number.match(re) != null) return "amex";

      re = new RegExp(/^5[1-5][0-9]{14}$|^2(?:2(?:2[1-9]|[3-9][0-9])|[3-6][0-9][0-9]|7(?:[01][0-9]|20))[0-9]{12}$/);
      if (number.match(re) != null) return "mastercard";

      re = new RegExp(/^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$/);
      if (number.match(re) != null) return "discover";
      
      re = new RegExp(/^(5018|5081|5044|5020|5038|603845|6304|6759|676[1-3]|6799|6220|504834|504817|504645)[0-9]{8,15}$/);
      if (number.match(re) != null) return 'maestro';

      re = new RegExp(/^(?:2131|1800|35[0-9]{3})[0-9]{11}$/);
      if (number.match(re) != null) return 'jcb';

      re = new RegExp(/^3(?:0[0-5]|[68][0-9])[0-9]{11}$/);
      if (number.match(re) != null) return 'diners';

      re = new RegExp(/^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^50(4175|6699|67[0-6][0-9]|677[0-8]|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9])|^627780|^63(6297|6368|6369)|^65(0(0(3([1-3]|[5-9])|4([0-9])|5[0-1])|4(0[5-9]|[1-3][0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8]|4[1-9]|[5-8][0-9]|9[0-8])|7(0[0-9]|1[0-8]|2[0-7])|9(0[1-9]|[1-6][0-9]|7[0-8]))|16(5[2-9]|[6-7][0-9])|50(0[0-9]|1[0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/);
      if (number.match(re) != null) return 'elo';

      re = new RegExp(/^606282|^3841(?:[0|4|6]{1})0/);
      if (number.match(re) != null) return 'hipercard';


      return ""; // default type
    },
		generateCardNumberMask () {
			return this.getCardType === "amex" ? this.amexCardMask : this.otherCardMask;
    },
    minCardMonth () {
      if (this.cardYear === this.minCardYear) return new Date().getMonth() + 1;
      return 1;
    }
  },
  watch: {
    cardYear () {
      if (this.cardMonth < this.minCardMonth) {
        this.cardMonth = "";
      }
    }
  },
  methods: {
    flipCard (status) {
      this.isCardFlipped = status;
    },
    focusInput (e) {
      this.isInputFocused = true;
      let targetRef = e.target.dataset.ref;
      let target = this.$refs[targetRef];
      this.focusElementStyle = {
        width: `${target.offsetWidth}px`,
        height: `${target.offsetHeight}px`,
        transform: `translateX(${target.offsetLeft}px) translateY(${target.offsetTop}px)`
      }
    },
    blurInput() {
      let vm = this;
      setTimeout(() => {
        if (!vm.isInputFocused) {
          vm.focusElementStyle = null;
        }
      }, 300);
      vm.isInputFocused = false;
    },
    async getData(){
      let creditcardData = {
        number: this.cardNumber,
        name: this.cardName,
        month: this.cardMonth,
        year: this.cardYear,
        cvv: this.cardCvv
      }

      return creditcardData;
    },
    async validated(){
      let res = {};
      let errMsg = "";

      this.errNumber = !this.cardNumber || this.getCardType == "";
      this.errName = !this.cardName;
      this.errMonth = !this.cardMonth || this.cardMonth == "Mês";
      this.errYear = !this.cardYear || this.cardYear == "Ano";
      this.errCvv = !this.cardCvv;

      if (!this.cardNumber) {errMsg = "Por favor informe o número do cartão de crédito";}
      else if (this.getCardType == "") {errMsg = "Por favor utilize um cartão de crédito das bandeiras VISA, MASTERCARD, ELO, DINERS, AMEX, ou HIPERCARD";}
      else if (this.errName) {errMsg = "Por favor informe o nome que consta no cartão de crédito";}
      else if (this.errMonth) {errMsg = "Por favor informe a validade do cartão de crédito";}
      else if (this.errYear) {errMsg = "Por favor informe a validade do cartão de crédito";}
      else if (this.errCvv) {errMsg = "Por favor informe o CVV que consta no verso cartão de crédito";}

      if (errMsg){
        res.status = "error";
        res.msg = errMsg;
      } else {
        res.status = "success";
      }

      return res;
    }
  }
}
</script>

<style scoped lang="scss">
  @import "./CreditCard.scss";

  .error {
    color: red !important;
    border-color: red !important;
  }
</style>